import { GridSortRequest, GridSortModel } from './sort';
import { PaginationRequestInterface } from './pagination'

import AustralianState from './AustralianState'
import SerialNumber from './SerialNumber'

export default class RecRegistryAction {
  id = ""
  accreditationCodeId = ""
  certificateTypeId?: string
  registeredPersonNumber = 0
  ownerAccountId = 0
  ownerAccountName = ""
  category = RecRegistryActionCategory.certificate
  result = RecRegistryActionResult.created
  status = RecRegistryStatus.registered
  completedAt = new Date()
  generationYear = 0
  serialNumber = new SerialNumber({})
  serialNumberStart = 0
  serialNumberEnd = 0
  fuelSource = RecRegistryFuelSource.solar
  generationState = AustralianState.VIC
  processingAction = RecRegistryProcessingAction.process
  processingErrorCategory?: string = undefined

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  constructor(obj: any) {
    Object.assign(this, obj)
    this.completedAt = new Date(obj.completedAt)
    this.serialNumber = new SerialNumber(obj.serialNumber)
    this.processingAction = (<any>RecRegistryProcessingAction)[obj.processingAction]
    this.certificateTypeId = obj.certificateType.id
  }
}

enum RecRegistryActionCategory {
  certificate = "certificate",
  audit = "audit",
  transfer = "transfer",
  surrender = "surrender",
  voluntarySurrender = "voluntarySurrender",
  clearingHouse = "clearingHouse",
  clearingHouseTransfer = "clearingHouseTransfer",
  stcToLgcConversion = "stcToLgcConversion",
  lgscRefundSurrender = "lgscRefundSurrender",
}

enum RecRegistryActionResult {
  created = "created",
  registered = "registered",
  passed = "passed",
  failed = "failed",
  offer = "offer",
  requested = "requested",
  buy = "buy",
  sell = "sell",
  sold = "sold",
  withdrawn = "withdrawn",
  accepted = "accepted",
  rejected = "rejected",
  cancelled = "cancelled",
}

export enum RecRegistryStatus {
  registered = "Registered",
  invalidDueToClearingHouseDeficit = "Invalid due to STC clearing house deficit",
  invalidDueToSurrender = "Invalid due to surrender",
  pendingTransfer = "Pending transfer",
  pendingSurrender = "Pending surrender",
  invalidDueToAudit = "Invalid due to audit",
  pendingAudit = "Pending audit",
  pendingCreationFeePayment = "Pending creation fee payment",
  pendingClearingHouseSale = "Pending STC clearing house sale",
  pendingClearingHouseTransfer = "STC clearing house pending transfer",
  pendingVoluntarySurrender = "Pending voluntary surrender",
  lgcsPendingSurrenderForRefund = "LGCs pending surrender for refund",
  invalidDueToVoluntarySurrender = "Invalid due to voluntary surrender",
  invalidDueToRefundSurrender = "Invalid due to LGSC refund surrender",
}

export enum RecRegistryProcessingAction {
  process,
  ignore,
  error,
}

export enum RecRegistryFuelSource {
  agriculturalWaste = "Agricultural waste",
  bagasse = "Bagasse",
  bagasseCogeneration = "Bagasse co-generation",
  biomassBasedComponentsofSolidWaste = "Biomass-based components of municipal solid waste",
  blackLiquor = "Black liquor",
  cropWaste = "Crop waste",
  energyCrops = "Energy crops",
  foodWetWaste = "Food and agricultural wet waste",
  foodProcessingWaste = "Food processing waste",
  foodWaste = "Food waste",
  geothermalAquifier = "Geothermal-aquifer",
  hotDryRock = "Hot dry rock",
  hydro = "Hydro",
  landfillGas = "Landfill gas",
  solidWasteCombustion = "Municipal solid waste combustion",
  ocean = "Ocean",
  photovoltaic = "Photovoltaic",
  regulatorCreatedDeemed = "Regulator created (deemed)",
  sguHydroDeemed = "S.G.U. - hydro (deemed)",
  sguSolarDeemed = "S.G.U. - solar (deemed)",
  sguWindDeemed = "S.G.U. - wind (deemed)",
  swhAirSourceHeatPumpDeemed = "S.W.H. - air source heat pump (deemed)",
  swhSolarDeemed = "S.W.H. - solar (deemed)",
  sewageGas = "Sewage gas",
  sewageGasAndBiomass = "Sewage gas and biomass-based components of sewage",
  solarWaterHeaterDeemed = "Solar water heater (deemed)",
  solar = "Solar",
  tide = "Tide",
  wasteCoalMineGas = "Waste coal mine gas",
  wasteProcessingAgriculturalProducts = "Waste from processing of agricultural products",
  wave = "Wave",
  wind = "Wind",
  woodWaste = "Wood waste",
}

// Request

export class RecRegistryActionRequest implements PaginationRequestInterface, GridSortRequest {
  accreditationCodeId?: string
  generationId?: string
  processingError?: boolean
  serialNumber?: number
  sort?: GridSortModel
  sortDesc?: boolean
  per = 25
  page = 0

  static copy(from: RecRegistryActionRequest): RecRegistryActionRequest {
    const newRequest = new RecRegistryActionRequest()
    Object.assign(newRequest, from)
    return newRequest
  }
}

